// extracted by mini-css-extract-plugin
export var imageWrapper = "ArticleCard-module--imageWrapper--N6M8h";
export var label = "ArticleCard-module--label--y3o-b";
export var preamble = "ArticleCard-module--preamble--COV12";
export var title = "ArticleCard-module--title--vXfW7";
export var wrapper = "ArticleCard-module--wrapper--3Pc64";